import Vue from 'vue'

export default {
  list (config = {}) {
    return Vue.http.get('/slotting/dashboard', {
      ...config
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/slotting/dashboard.js